// test284
(284 && 0);
